type AppId = 'admin' | 'accounting' | 'portfolio' | 'business';

// Configuration des URLs des applications externes
export const APP_URLS = {
  // Application de comptabilité
  ACCOUNTING: import.meta.env.VITE_ACCOUNTING_URL,
  
  // Application de gestion de portefeuille
  PORTFOLIO: import.meta.env.VITE_PORTFOLIO_URL,
  
  // Application de gestion commerciale (mobile)
  BUSINESS_ANDROID: import.meta.env.VITE_BUSINESS_ANDROID_URL,
  BUSINESS_IOS: import.meta.env.VITE_BUSINESS_IOS_URL,
};

// Fonction utilitaire pour détecter le type d'appareil
export const getDeviceType = () => {
  // `opera` et `MSStream` : propriétés non standard d'anciens navigateurs.
  const legacyWindow = window as Window & { opera?: string; MSStream?: unknown };
  const userAgent = navigator.userAgent || navigator.vendor || legacyWindow.opera || '';
  
  if (/android/i.test(userAgent)) {
    return 'android';
  }
  
  if (/iPad|iPhone|iPod/.test(userAgent) && !legacyWindow.MSStream) {
    return 'ios';
  }
  
  return 'desktop';
};

// Fonction pour vérifier si une application est disponible
export const isAppAvailable = (appType: AppId): boolean => {
  switch (appType) {
    case 'accounting':
      return !!APP_URLS.ACCOUNTING;
    case 'portfolio':
      return !!APP_URLS.PORTFOLIO;
    case 'business':
      return !!APP_URLS.BUSINESS_ANDROID || !!APP_URLS.BUSINESS_IOS;
    default:
      return false;
  }
};

// Fonction pour ouvrir l'application appropriée selon le contexte
export const openExternalApp = (appType: AppId) => {
  try {
    switch (appType) {
      case 'accounting':
        if (!APP_URLS.ACCOUNTING) {
          throw new Error('URL de l\'application Comptabilité non configurée');
        }
        window.open(APP_URLS.ACCOUNTING, '_blank');
        break;
        
      case 'portfolio':
        if (!APP_URLS.PORTFOLIO) {
          throw new Error('URL de l\'application Gestion de Portefeuille non configurée');
        }
        window.open(APP_URLS.PORTFOLIO, '_blank');
        break;
        
      case 'business': {
        const deviceType = getDeviceType();
        if (deviceType === 'android') {
          if (!APP_URLS.BUSINESS_ANDROID) {
            throw new Error('URL du Play Store non configurée');
          }
          window.open(APP_URLS.BUSINESS_ANDROID, '_blank');
        } else if (deviceType === 'ios') {
          if (!APP_URLS.BUSINESS_IOS) {
            throw new Error('URL de l\'App Store non configurée');
          }
          window.open(APP_URLS.BUSINESS_IOS, '_blank');
        } else {
          // Pour desktop, afficher un message informatif
          alert('L\'application de Gestion Commerciale est disponible uniquement sur mobile. Veuillez télécharger l\'application depuis votre store mobile (Google Play Store ou App Store).');
        }
        break;
      }
        
      default:
        throw new Error(`Type d'application non reconnu: ${appType}`);
    }
  } catch (error) {
    console.error('Erreur lors de l\'ouverture de l\'application:', error);
    alert(`Impossible d'ouvrir l'application: ${error instanceof Error ? error.message : 'Erreur inconnue'}`);
  }
};